import { render, staticRenderFns } from "./department-left.vue?vue&type=template&id=8bcb241c&scoped=true"
import script from "./department-left.vue?vue&type=script&lang=js"
export * from "./department-left.vue?vue&type=script&lang=js"
import style0 from "./department-left.vue?vue&type=style&index=0&id=8bcb241c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bcb241c",
  null
  
)

export default component.exports